import ResourceGetter
  from '../../../../../model/resource/getter/resource-getter'

export default {
  props: ['user'],

  data () {
    return {
      password:       null,
      passwordVerify: null,
      errors:         {},

      resource: null
    }
  },

  created () {
    this.resource = ResourceGetter.get('tUser')
  }

}
